import styled from '@emotion/styled';
import tw, { css } from 'twin.macro';

export const highlightStyle = css`
  border-radius: 1em 0 1em 0;
  background-image: linear-gradient(
    -100deg,
    rgba(255, 224, 0, 0.3),
    rgba(255, 224, 0, 0.7) 95%,
    rgba(255, 224, 0, 0.1)
  );
`;

export const HighlightQuote = styled.div`
  p {
    ${tw`mb-0`}
  }

  strong {
    ${tw`font-bold`}
    ${highlightStyle}
  }
`;
